import { render } from "./FontStyleEditor.vue?vue&type=template&id=5df74d1a"
import script from "./FontStyleEditor.vue?vue&type=script&lang=js"
export * from "./FontStyleEditor.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__